export const CheckSensitiveWordService = Symbol('CheckSensitiveWordService');

export interface CheckSensitiveWordService {
    checkSensitiveWord: (word: string) => Promise<string>;
}
